import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import Timeline from '../../components/Timeline.js';
import DetailsComponent from "../../components/DetailsComponent";
import { getApi } from '../../api/endpoints.js';
import WorkOrder from '../../models/WorkOrder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointRight } from '@fortawesome/free-solid-svg-icons';

const Show = () => {
  const [workOrderDetails, setWorkOrderDetails] = useState(new WorkOrder().toStateJson());
  const [fetchApi] = getApi('showWorkOrder');
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setWorkOrderDetails((new WorkOrder(response.data.work_order)).toStateJson());
    } catch (error) {
    }
  }

  const timelineData = workOrderDetails.version_details;

  return <Page
    key={PAGES.ShowWorkOrdersPage.name}
    uiPage={uiManager.getUiPage(PAGES.ShowWorkOrdersPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Work Orders", url: "/work_orders" }, { label: "Details" }]}
    className={'view-work-order-page'}
  >
    <PageContentWrapper contentHeading={'Work Order Details'}>
    <div className='m-2'>
        {
          workOrderDetails.work_order_details &&
          <div className='row'>
            <div className='col-1'>
              <p className='pt-1 fw-bold'>Work Order Details <FontAwesomeIcon icon={faHandPointRight}/></p>
            </div>
            <div className='col'>
              <DetailsComponent data={workOrderDetails.work_order_details}/>
            </div>
          </div>
        }
        {
        Object.keys(workOrderDetails.raised_for).length !== 0 &&
          <div className='row'>
            <div className='col-1'>
              <p className='pt-1 fw-bold'>Raised For User <FontAwesomeIcon icon={faHandPointRight}/></p>
            </div>
            <div className='col'>
              <DetailsComponent data={workOrderDetails.raised_for}/>
            </div>
          </div>
        }
        {
          Object.keys(workOrderDetails.handler_details).length !== 0 &&
          <div className='row'>
            <div className='col-1'>
              <p className='pt-1 fw-bold'>Handled By<FontAwesomeIcon icon={faHandPointRight} className="ms-2"/></p>
            </div>
            <div className='col'>
              <DetailsComponent data={workOrderDetails.handler_details}/>
            </div>
          </div>
        }
        {
          Object.keys(workOrderDetails.service_center_details).length !== 0 &&
          <div className='row'>
              <div className='col-1'>
              <p className='pt-1 fw-bold'>Service Center<FontAwesomeIcon icon={faHandPointRight} className="ms-2"/></p>
            </div>
            <div className='col'>
              <DetailsComponent data={workOrderDetails.service_center_details}/>
            </div>
          </div>
        }
        <hr />
        {
          workOrderDetails.version_details.length !== 0 &&
          <div className='row'>
            <h6 className='text-success p-4'>Complaint History</h6>
            <div className='col'>
              <Timeline timelineData={timelineData}/>
            </div>
          </div>
        }
      </div>
    </PageContentWrapper>
  </Page>
};

export default Show;
